import { useContext } from "react";
import { CaseFilesContext } from "./CaseFilesContext";

export const useCaseFiles = () => {
  const context = useContext(CaseFilesContext);

  if (!context) {
    throw new Error("useCaseFiles must be used within a CaseFilesProvider");
  }

  return context;
};
